<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    <h2> Parametry</h2>
  </div>

  <div fxFlex="100">
    <mat-slide-toggle color="accent" [formControl]="policyEnabledControl" > Polisowanie </mat-slide-toggle>
  </div>

  <div fxFlex="100">
    <mat-slide-toggle color="accent" [formControl]="accreditationControl"> Aktywna </mat-slide-toggle>
  </div>

  <div fxFlex="100">
    <mat-slide-toggle color="accent" [formControl]="paymentCashControl"> Gotówka </mat-slide-toggle>
  </div>

  <div fxFlex="100">
    <mat-slide-toggle color="accent" [formControl]="paymentCardControl"> Karta </mat-slide-toggle>
  </div>

  <div fxFlex="100">
    <mat-slide-toggle color="accent" [formControl]="paymentTransferControl"> Przelew </mat-slide-toggle>
  </div>

  <div fxFlex="100">
    <mat-slide-toggle color="accent" [formControl]="offerSavingControl"> Dostrajanie oferty </mat-slide-toggle>
  </div>


  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest "
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

